/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_Key_PlaceholderInputs */

const en_admin_settings_custom_key_placeholder = /** @type {(inputs: Admin_Settings_Custom_Key_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`config_key`)
};

/**
* | output |
* | --- |
* | "config_key" |
*
* @param {Admin_Settings_Custom_Key_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_key_placeholder = /** @type {((inputs?: Admin_Settings_Custom_Key_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_Key_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_custom_key_placeholder(inputs)
});
export { admin_settings_custom_key_placeholder as "admin.settings.custom.key_placeholder" }